import React from "react";
import Secone from "./secone";
import Navbars from "../Components/navbar";
import Footer from "../Components/Footer";


const Contactlink = () => {
    return(
        <>
        <Navbars />
        <Secone />
        <Footer />
        </>
    )
}

export default Contactlink;